// src/admin/components/BatchPdfGenerationModal.js

import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import ProgressBar from 'react-bootstrap/ProgressBar';
import PdfGenerationModal from './PdfGenerationModal';

function BatchPdfGenerationModal({ show, orders, onHide, onSuccess, apiBaseUrl }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isProcessing, setIsProcessing] = useState(false);
    
    // Modal açıldığında işlemi başlat
    useEffect(() => {
        if (show && orders.length > 0) {
            setCurrentIndex(0);
            setIsProcessing(true);
        } else {
            setIsProcessing(false);
        }
    }, [show, orders]);

    const handleSinglePdfSuccess = () => {
        const nextIndex = currentIndex + 1;
        if (nextIndex < orders.length) {
            // Bir sonraki siparişe geç
            setCurrentIndex(nextIndex);
        } else {
            // Tüm siparişler tamamlandı
            setIsProcessing(false);
            // Başarı mesajı sonrası ana listeyi yenilemek için onSuccess'i çağır
            onSuccess();
        }
    };
    
    // Eğer işlemde değilsek veya sipariş yoksa hiçbir şey render etme
    if (!isProcessing || !orders || orders.length === 0) {
        // Bu modal sadece bir yönetici, kendi arayüzü çok basit
        return (
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Preparing...</Modal.Title>
                </Modal.Header>
                <Modal.Body>Please wait while the batch process starts.</Modal.Body>
            </Modal>
        );
    }
    
    const currentOrder = orders[currentIndex];
    const progress = Math.round(((currentIndex + 1) / orders.length) * 100);

    return (
        <>
            {/* Arka planda çalışan asıl PDF oluşturma modalı */}
            <PdfGenerationModal
                show={isProcessing}
                order={currentOrder}
                // Bu modalın kendi kapatma fonksiyonu olmamalı, yönetici kapatmalı
                onHide={() => {}} 
                onSuccess={handleSinglePdfSuccess}
                apiBaseUrl={apiBaseUrl}
            />

            {/* Kullanıcıya ilerlemeyi gösteren modal */}
            <Modal show={show} onHide={onHide} centered backdrop="static">
                <Modal.Header>
                    <Modal.Title>Batch Processing Orders</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Processing order <strong>{currentIndex + 1} of {orders.length}</strong>:
                        <br />
                        #{currentOrder.order_id}
                    </p>
                    <ProgressBar now={progress} label={`${progress}%`} animated />
                    <p className="mt-3 text-muted">
                        Please do not close this window. The process will continue automatically.
                    </p>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default BatchPdfGenerationModal;